"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valvarrone": {
    "e371ab85": [{
      "hkey": "da9337e9",
      "slug": "tremenico-avano",
      "name": "Tremenico-Avano",
      "primary": true,
      "skipSearch": false
    }],
    "avano": [{
      "hkey": "da9337e9",
      "slug": "tremenico-avano",
      "name": "Tremenico-Avano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valvarrone"
    }],
    "c6fe4094": [{
      "hkey": "da9337e9",
      "slug": "tremenico-avano",
      "name": "Tremenico-Avano",
      "primary": true,
      "skipSearch": false
    }],
    "tremenico": [{
      "hkey": "da9337e9",
      "slug": "tremenico-avano",
      "name": "Tremenico-Avano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a45abd68": [{
      "hkey": "9762d1de",
      "slug": "roccoli-lorla",
      "name": "Roccoli-Lorla",
      "primary": true,
      "skipSearch": false
    }],
    "rifugio-roccoli-lorla": [{
      "hkey": "9762d1de",
      "slug": "roccoli-lorla",
      "name": "Roccoli-Lorla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;